import React from 'react';
import { IconSVG } from './IconSVG';

interface Props {
  width?: number;
  height?: number;
  color?: string;
  fillColor?: string;
  strokeWidth?: number | string;
}

// TODO: fix lint errors
/* eslint-disable */
export function createSvgIcon(
  name,
  path,
  viewBoxWidth,
  viewBoxHeight,
  defaultColor,
  defaultFillColor = null,
  defaultStrokeWidth = null
) {
  return ({
    width,
    height,
    color = '',
    fillColor = '',
    strokeWidth = '',
    ...props
  }: Props) => {
    const iconColor = color || defaultColor;
    const iconWidth = width || viewBoxWidth;
    const iconHeight = height || viewBoxHeight;
    const iconStrokeWidth = strokeWidth || defaultStrokeWidth;
    const iconFillColor = fillColor || defaultFillColor || iconColor;

    return (
      <IconSVG width={iconWidth} height={iconHeight} name={name} {...props}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
          stroke={iconColor}
          strokeWidth={iconStrokeWidth}
          fill={iconFillColor}
        >
          {path}
        </svg>
      </IconSVG>
    );
  };
}
